import React, { useEffect, useState } from "react";
import VenueDetailsTab from "./Components/VenueDetailsTab";
import OtherDetailsTab from "./Components/OtherDetailsTab";
import VenueImagesTab from "./Components/VenueImagesTab";
import "./UpdateVenue.css";
import { getVenueById } from "../../../api";

const TAB_CONFIG = [
  { id: 1, label: "Details", icon: "fa-solid fa-circle-info" },
  { id: 2, label: "Additional Details", icon: "fa-solid fa-list-check" },
  { id: 3, label: "Upload Images", icon: "fa-solid fa-image" },
];

/**
 * Update Venue — edit/add held for now (signup + login only).
 * Auto-create venue / venue_user repair stays commented until DB approach is decided.
 */
const UpdateVenue = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [venueData, setVenueData] = useState<any>(null);
  const [venueId, setVenueId] = useState<number | null>(null);

  const canAccessTab = () => true;

  const goToTab = (tab: number, e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (!canAccessTab() || isLoading) return;
    setActiveTab(tab);
  };

  const fetchVenue = async () => {
    try {
      setIsLoading(true);

      const stored = localStorage.getItem("venueData");
      if (!stored) return;

      const userId = JSON.parse(stored).userId;
      if (!userId) return;

      const response = await getVenueById(userId);

      setVenueData(response);
      setVenueId(response?.venue_id);
    } catch (err) {
      console.error("Failed to fetch venue", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchVenue();
  }, []);

  return (
    <div className="update-venue-page">
      <div className="event-dt-block">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-12 col-lg-9 col-md-12">
              <div className="wizard-steps-block">
                <div className="step-app">
                  <ul className="step-steps">
                    {TAB_CONFIG.map(({ id, label, icon }) => {
                      const isActive = activeTab === id;
                      const accessible = canAccessTab() && !isLoading;
                      return (
                        <li key={id} className={isActive ? "active" : ""}>
                          <a
                            href={`#tab_step${id}`}
                            onClick={(e) => goToTab(id, e)}
                            className={!accessible ? "disabled" : ""}
                            aria-disabled={!accessible}
                            tabIndex={!accessible ? -1 : 0}
                            style={{
                              pointerEvents: !accessible ? "none" : "auto",
                              opacity: !accessible ? 0.5 : 1,
                            }}
                          >
                            <span>
                              <i className={icon} />
                            </span>
                            <span>{label}</span>
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                  <div className="step-content">
                    {activeTab === 1 && (
                      <VenueDetailsTab
                        venueData={venueData}
                        venueId={venueId}
                        isLoading={isLoading}
                        refreshVenue={fetchVenue}
                      />
                    )}
                    {activeTab === 2 && (
                      <OtherDetailsTab
                        venueData={venueData}
                        venueId={venueId}
                        isLoading={isLoading}
                        refreshVenue={fetchVenue}
                      />
                    )}
                    {activeTab === 3 && (
                      <VenueImagesTab
                        venueData={venueData}
                        venueId={venueId}
                        refreshVenue={fetchVenue}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateVenue;
